const FBEVENTS_SRC = "https://connect.facebook.net/en_US/fbevents.js";

type Fbq = {
  (...args: unknown[]): void;
  callMethod?: (...args: unknown[]) => void;
  queue: unknown[][];
  push: Fbq;
  loaded: boolean;
  version: string;
};

declare global {
  interface Window {
    fbq?: Fbq;
    _fbq?: Fbq;
  }
}

/**
 * Meta's base code, written out: a queue stub replays calls made before
 * fbevents.js arrives. Fires the initial PageView for the current page.
 */
export function loadMetaPixel(pixelId: string): void {
  if (window.fbq) return;

  const fbq = function (...args: unknown[]) {
    if (fbq.callMethod) {
      fbq.callMethod(...args);
    } else {
      fbq.queue.push(args);
    }
  } as Fbq;
  fbq.queue = [];
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = "2.0";
  window.fbq = fbq;
  window._fbq = fbq;

  const script = document.createElement("script");
  script.async = true;
  script.src = FBEVENTS_SRC;
  document.head.appendChild(script);

  fbq("init", pixelId);
  fbq("track", "PageView");
}

/** Client-side navigations don't reload the page, so PageView is fired by hand. */
export function trackPageView(): void {
  window.fbq?.("track", "PageView");
}

/** Standard Meta event for a waitlist signup; a no-op until the visitor has accepted marketing cookies. */
export function trackLead(): void {
  window.fbq?.("track", "Lead");
}

export type StorePlatform = "ios" | "android";
export type StorePlacement = "hero" | "header";

/**
 * Custom Meta event for a click on an App Store / Google Play button: the
 * site's real conversion now that the app is live. A no-op until the visitor
 * has accepted marketing cookies.
 */
export function trackStoreClick(platform: StorePlatform, placement: StorePlacement): void {
  window.fbq?.("trackCustom", "StoreClick", { platform, placement });
}
